import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import logo from '../assets/logo.jpeg';

const Login = () => {
  const [loginId, setLoginId] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { login } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const success = await login(loginId, password);
      if (success) {
        navigate('/dashboard');
      } else {
        setError('Login failed. Please check your credentials.');
      }
    } catch (err) {
      setError(err.message || 'An error occurred');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#0F2F3D] to-[#091E28] px-5">

      <div className="w-full max-w-md bg-white/95 backdrop-blur-lg rounded-2xl shadow-2xl p-10 relative overflow-hidden">

        {/* Top Accent Bar */}
        <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-[#E4572E] to-[#F47C4D]"></div>

        {/* Logo */}
        <div className="flex flex-col items-center mb-6">
          <img src={logo} alt="Desi Mart" className="w-20 h-20 object-contain mb-3" />
          <h1 className="text-2xl font-bold text-[#0F2F3D] tracking-wide">
            Welcome Back
          </h1>
          <p className="text-sm text-gray-500">
            Login to continue your journey
          </p>
        </div>

        {/* Error Message */}
        {error && (
          <div className="mb-4 px-4 py-2 rounded-lg bg-red-100 text-red-600 text-sm font-medium">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-5">

          {/* Email or Sponsor ID */}
          <div>
            <label className="block mb-2 text-sm font-semibold text-[#0F2F3D]">
              Login ID
            </label>
            <input
              type="text"
              value={loginId}
              onChange={(e) => setLoginId(e.target.value)}
              required
              placeholder="Enter your login ID"
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:border-[#E4572E] focus:ring-2 focus:ring-[#E4572E]/20 transition-all"
            />
            <p className="text-xs text-gray-500 mt-1">
              You can login with your login ID (e.g., DMC12345)
            </p>
          </div>

          {/* Password */}
          <div>
            <label className="block mb-2 text-sm font-semibold text-[#0F2F3D]">
              Password
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              placeholder="Enter your password"
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:border-[#E4572E] focus:ring-2 focus:ring-[#E4572E]/20 transition-all"
            />
          </div>

          {/* Forgot Password */}
          <div className="text-right">
            <Link
              to="/forgot-password"
              className="text-sm text-[#E4572E] hover:underline"
            >
              Forgot Password?
            </Link>
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            disabled={loading}
            className="w-full py-3 rounded-lg bg-gradient-to-r from-[#E4572E] to-[#F47C4D] text-white font-semibold shadow-md hover:opacity-90 transition-all duration-300"
          >
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>

        {/* Register Link */}
        <p className="text-center mt-6 text-sm text-gray-600">
          Don't have an account?{' '}
          <Link
            to="/register"
            className="text-[#0F2F3D] font-semibold hover:text-[#E4572E] transition-colors"
          >
            Create Account
          </Link>
        </p>

      </div>
    </div>
  );
};

export default Login;